/* eslint-disable @typescript-eslint/no-use-before-define,@typescript-eslint/no-redeclare */
export var Resolvable;
(function (_Resolvable) {
  function resolve(value) {
    if (typeof value === 'function') {
      return value();
    }
    return value;
  }
  _Resolvable.resolve = resolve;
})(Resolvable || (Resolvable = {}));
export var AsyncResolvable;
(function (_AsyncResolvable) {
  function resolve() {
    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }
    if (values.length === 1) {
      var [_value] = values;
      return resolveAsyncOne(_value);
    }
    var resolutions = values.map(value => resolveAsyncOne(value));
    return Promise.all(resolutions);
  }
  _AsyncResolvable.resolve = resolve;
})(AsyncResolvable || (AsyncResolvable = {}));
function resolveAsyncOne(value) {
  if (typeof value === 'function') {
    return Promise.resolve(value());
  }
  return value;
}